import classNames from 'classnames';

import logoLight from '../../../assets/img/odu-yatay.png';
import logoDark from '../../../assets/img/oduk.png';
import doku from '../../../assets/img/bd-doku2.png';

import SubMenu from './SubMenu';

import { BiAlbum, BiConversation, BiPieChartAlt } from 'react-icons/bi';

import { BsGear, BsArrowLeftShort } from 'react-icons/bs';

const Sidebar = (props) => {
  const menuData = [
    {
      name: 'DASHBOARD',
      url: null,
      submenu: null,
    },
    {
      name: 'Başvurular',
      url: '/sedmin/basvurular',
      icon: <BiAlbum />,
      submenu: null,
    },
    {
      name: 'Dönem İşlemleri',
      url: '/sedmin/donem-islemleri',
      icon: <BiConversation />,
      submenu: null,
    },
    // {
    // 	name: 'Contacts',
    // 	url: '/',
    // 	icon: <BiSearch />,
    // 	submenu: null,
    // },
    // {
    // 	name: 'Help Center',
    // 	url: '/',
    // 	icon: <BiLinkAlt />,
    // 	submenu: null,
    // },
    {
      name: 'SİSTEM YÖNETİCİSİ',
      url: null,
      submenu: null,
    },
    // {
    // 	name: 'Birim Ağacı',
    // 	url: '/',
    // 	icon: <BiPieChartAlt />,
    // 	submenu: null,
    // },
    {
      name: 'Yetkili Tanımlama',
      url: '/sedmin/kullanici-islemleri',
      icon: <BiPieChartAlt />,
      submenu: null,
    },
    {
      name: 'Ayarlar',
      url: '/sedmin/ayarlar',
      icon: <BiPieChartAlt />,
      submenu: null,
    },
    // {
    // 	name: 'Hizmetler',
    // 	url: '/hizmetler',
    // 	icon: <BiAlbum />,
    // 	submenu: [
    // 		{
    // 			name: 'Web Tasarım',
    // 			url: '/hizmetler/web-tasarim',
    // 			submenu: null,
    // 		},
    // 		{
    // 			name: 'Mobil Uygulama',
    // 			url: '/hizmetler/mobil-uygulama',
    // 			submenu: [
    // 				{
    // 					name: 'Web Tasarım',
    // 					url: '/hizmetler/web-tasarim',
    // 					submenu: null,
    // 				},
    // 				{
    // 					name: 'Mobil Uygulama',
    // 					url: '/hizmetler/mobil-uygulama',
    // 					submenu: null,
    // 				},
    // 			]
    // 		},
    // 	]
    // },
  ];

  return (
    <>
      {
        //<div className="md:flex md:w-16 md:flex-col md:fixed md:inset-y-0"></div>
        //<div className="md:flex md:w-64 md:ms-16 md:flex-col md:fixed md:inset-y-0 border-r border-slate-200 dark:border-slate-500"></div>
        <div className="relative z-50">
          <div
            className={classNames({
              'flex w-64 flex-col fixed inset-y-0 border-r border-slate-200 ':
                props.isOpenSidebar === true,
              hidden: props.isOpenSidebar === false,
            })}
          >
            <div className="flex flex-col flex-grow bg-white  overflow-y-auto rounded-tl-2xl rounded-bl-2xl">
              <div
                className="flex h-24 flex-shrink-0 w-full items-center justify-between pl-4 pr-0"
                style={{
                  backgroundImage: `url(${doku})`,
                  backgroundRepeat: 'repeat-x',
                }}
              >
                {props.darkMode ? (
                  <img src={logoDark} className="h-14" alt="" />
                ) : (
                  <img src={logoLight} className="h-14" alt="" />
                )}
                <button
                  className="md:hidden"
                  onClick={() => {
                    props.setIsOpenSidebar(!props.isOpenSidebar);
                  }}
                >
                  <BsArrowLeftShort className="text-4xl text-slate-500 hover:text-slate-400" />
                </button>
              </div>
              <div className="overflow-y-auto scrollbar-thin scrollbar-track-slate-200 scrollbar-thumb-slate-300 hover:scrollbar-thumb-slate-400">
                <div className="relative h-full w-full">
                  <div className="px-4 pb-8">
                    <SubMenu data={menuData} />
                  </div>
                </div>
              </div>
              <div className="mt-auto mb-4 py-2 mx-2   rounded-lg px-4 bg-slate-100   text-center flex items-center justify-between text-slate-500">
                <div className="text-left">
                  <h1 className="font-semibold text-sm">
                    {localStorage.getItem('adsoyad')
                      ? localStorage.getItem('adsoyad')
                      : ''}
                  </h1>
                  <span className="text-xs">
                    {localStorage.getItem('role')
                      ? localStorage.getItem('role')
                      : ''}
                  </span>
                </div>
                <a
                  href="?"
                  className="hover:text-slate-700 text-slate-400 flex h-12 w-12 items-center justify-end rounded-2xl transition-colors duration-300"
                >
                  <BsGear className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default Sidebar;
